import gql from "graphql-tag"

export const TRACK_EVENT = gql`
  mutation trackEvent($email: String!, $data: String!, $type: String!) {
    trackEvent(
      input: {
        clientMutationId: "Track Active Campaign Event"
        email: $email
        data: $data
        type: $type
      }
    ) {
      response
    }
  }
`
